import { useMutation, useQueryClient } from '@tanstack/react-query';
import { productCategoryService } from 'shared/src/api';
import { queryKey } from 'mypage/src/constant/queryKey';

export const useDeleteProductCategoryMeasureValues = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (productCategorySno: number) =>
      productCategoryService.deleteProductCategoryMeasureValues(
        productCategorySno,
      ),
    onSuccess: (_data, productCategorySno) => {
      queryClient.invalidateQueries({
        queryKey: queryKey.productCategoryMeasureValues(productCategorySno),
      });
    },
  });
};
